import ScrollReveal from '@/components/ScrollReveal';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '@/components/ui/accordion';

const FAQS = [
  { q: 'What is a property inventory report?', a: 'A property inventory report is a detailed, photographic record of a property\u2019s condition and contents at the start of a tenancy. It includes time-stamped photographs, meter readings, and a detailed description of every room and fixture to protect both landlords and tenants in deposit disputes.' },
  { q: 'Will your report help in a deposit dispute?', a: 'Yes. Daley Inventories reports are detailed, photographic and independently prepared, which is the kind of evidence deposit protection schemes such as the TDS, DPS and mydeposits look at when they decide a dispute. No report can guarantee the outcome of a dispute.' },
  { q: 'How quickly will I receive my report?', a: 'Daley Inventories delivers reports within 24 to 48 hours of the inspection, by email as a PDF. The 4-hour express option costs £60 inc VAT.' },
  { q: 'How much does an inventory report cost?', a: 'At Daley Inventories, a property inventory starts at £120 including VAT for a studio, and a check-out starts at £108. The price depends on property size, whether it is furnished, and the type of service. You can see the full price list on our Pricing page or get an instant quote online.' },
  { q: 'Where do you provide inventory services?', a: 'We cover Greater London and Greater Manchester, including all surrounding boroughs. Our clerks are local to each area for prompt, reliable service.' },
  { q: 'Are your clerks insured?', a: 'Yes. Daley Inventories holds professional indemnity and public liability insurance, and our clerks are experienced in residential inventories, check-ins and check-outs.' },
];

export function buildCampaignFaqSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: FAQS.map(item => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
  };
}

export default function CampaignFaq() {
  return (
    <section className="py-16 md:py-32">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16">
        <ScrollReveal>
          <div className="text-center max-w-2xl mx-auto mb-16">
            <p className="caps-label text-orange mb-4">Inventory FAQs</p>
            <h2 className="font-display font-extrabold text-navy" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)' }}>
              Questions, answered
            </h2>
            <p className="text-lg text-muted-foreground mt-4">
              Everything landlords and agents need to know about our property inventory reports.
            </p>
          </div>
        </ScrollReveal>
        <ScrollReveal delay={0.1}>
          <div className="max-w-3xl mx-auto">
            <Accordion type="single" collapsible className="border-t border-navy/10">
              {FAQS.map((item, i) => (
                <AccordionItem key={i} value={`faq-${i}`} className="border-navy/10">
                  <AccordionTrigger className="text-base font-semibold text-navy hover:no-underline hover:text-orange py-6 text-left">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-base text-muted-foreground leading-relaxed">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}